"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redeemWinningNo = void 0;
const web3_js_1 = require("@solana/web3.js"); // eslint-disable-line @typescript-eslint/no-unused-vars
const programId_1 = require("../programId");
function redeemWinningNo(accounts) {
    const keys = [
        { pubkey: accounts.user, isSigner: false, isWritable: false },
        { pubkey: accounts.tradeNo, isSigner: false, isWritable: false },
        { pubkey: accounts.market, isSigner: false, isWritable: false },
        { pubkey: accounts.bracket, isSigner: false, isWritable: false },
        { pubkey: accounts.usdcVault, isSigner: false, isWritable: true },
        { pubkey: accounts.noMint, isSigner: false, isWritable: true },
        { pubkey: accounts.unlockedNo, isSigner: false, isWritable: true },
        { pubkey: accounts.internalUsdc, isSigner: false, isWritable: true },
        { pubkey: accounts.marketPnl, isSigner: false, isWritable: false },
        { pubkey: accounts.tokenProgram, isSigner: false, isWritable: false },
    ];
    const identifier = Buffer.from([168, 124, 136, 103, 216, 247, 30, 44]);
    const data = identifier;
    const ix = new web3_js_1.TransactionInstruction({ keys, programId: programId_1.PROGRAM_ID, data });
    return ix;
}
exports.redeemWinningNo = redeemWinningNo;
//# sourceMappingURL=redeemWinningNo.js.map